if (!window.endpointConfig || window.endpointConfig === undefined) {
  window.endpointConfig = {};
  window.endpointConfig.serviceApi = 'https://mdp-svc.mmis.arkansas.gov/';
  window.endpointConfig.webURI = 'https://mdp.mmis.arkansas.gov/';
}

const techConfig = {
  choosePreferredAppName: 'MyARMedicaid',
  defaultLocale: 'en',
  locale: [
    {
      key: 'en',
      value: 'English',
    },
    {
      key: 'es',
      value: 'Español',
    },
  ],
  timeFrames: [
    {
      key: '6 Months',
      value: 1,
    },
    {
      key: '12 Months',
      value: 2,
    },
    {
      key: 'Date Range',
      value: 3,
    },
  ],

  // serviceApi: 'https://sit-svc.mobiledigitalplatform.com/', // SIT URL
  // webURI: 'https://sharecard-sit.mobiledigitalplatform.com/', // NON Prod sharecard ARClientURL

  serviceApi1: 'https://mdp-dev-svc.mobiledigitalplatform.com/',
  // webURI: 'https://devprovider.mobiledigitalplatform.com/',

  // serviceApi: 'https://mdp-mo-svc.mobiledigitalplatform.com/', // MO Environment
  // webURI: 'https://mdp-mo.mobiledigitalplatform.com/', // MO Environment
  serviceApi: window.endpointConfig.serviceApi,
  webURI: window.endpointConfig.webURI,

  // serviceApi: 'https://mdp-svc.mmis.arkansas.gov/', // Prod ARClientURL
  // webURI: 'https://sharecard.mmis.arkansas.gov/', // Prod sharecard ARClientURL

  // serviceApi: 'https://mdp-nonprod-svc.mmis.arkansas.gov/', // NON Prod ARClientURL
  // webURI: 'https://sharecard-nonprod.mmis.arkansas.gov/', // NON Prod sharecard ARClientURL

  SupportBotApi:
    'https://westus.api.cognitive.microsoft.com/qnamaker/v2.0/knowledgebases/7e13a04b-af81-4b28-a653-3a84a452a63d/generateAnswer',
  build: 'DXC',
  landingPage: 'digitalCard',
  showCaptcha: false,
  isEnableMFA: true, // Business flag to indicate MFA implemented or not. (For Web temporarly make false)
  isAllowOptMFA: true, // When isEnableMFA = true, isAllowOptMFA flag allows user to select yes/no.
  DisplayWebPageFooter: false,
  enableAccessibilityFooterLink: false,
  accessibilityFooterLink: 'https://mdp-base.mobiledigitalplatform.com/',
  RetryMax: '3',
  barcodeDelimiter: '#',
  barcodeCode: '#MemberID',
  captchaURL: '//www.google.com/recaptcha/api.js?render=explicit&onload=vcRecaptchaApiLoaded',
  AppStoreURL: 'https://itunes.apple.com/us/app/mobile-digital-platform/id1309502726?ls=1&mt=8',
  googleAPIKey: 'AIzaSyBTU36XxstVlZZMLKOmqXYyz31AvN0uZ5E',
  googleURL: 'https://maps.googleapis.com/maps/api/geocode/json?address',
  googleSearchURL: 'https://www.google.com/maps/search/?api=1&query=',
  adminMemberID: '1231231231',
  messageBroadcastTopic: '/topics/news',
  token_expires_in_30: 30,
  alarm_timing: 1,
  Pending: 'P',
  Approve: 'A',
  Reject: 'R',
  Send: 'S',
  Failure: 'F',
  messagesAdmin: 'messagesAdmin',
  Location: 'Location',
  Distance: 'Distance',
  ProviderType: 'ProviderType',
  Specialty: 'Specialty',
  ProviderName: 'ProviderName',
  WebVersionNumber: '2.0 (5)',
  IsEnableMyHealthSummaryPDF: true,
};

export default techConfig;
